<template>
  <v-row align="center" justify="center" dense class="mb-4">
    <v-col cols="10"
           xl="6"
           lg="6"
           md="6"
           class="fill-height justify-center align-center text-left">
      <small> For any system related issues please send us a mail at
        <a :href="supportEmail">{{ this.contactDetails.supportEmail }}</a>
      </small>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: "SiteFooter",
  props: ['contactDetails'],
  computed: {
    supportEmail() {
      return 'mailto:' + this.contactDetails.supportEmail;
    }
  }
}
</script>

<style scoped>

</style>
